'use client';

import { Grid } from '@mui/material';
import FieldRenderer from '../FieldRenderer';
import { FormField } from '../../type';

type Props = {
  fields: FormField[];
};

const StepFields = ({ fields }: Props) => (
  <Grid container spacing={2}>
    {fields.map((field) => {
      const columns = ((field.width || 100) / 100) * 12;
      return (
        <Grid size={{ xs: 12, md: columns }} key={field.name}>
          <FieldRenderer field={field} />
        </Grid>
      );
    })}
  </Grid>
);

export default StepFields;
